import React, { Component } from 'react';
import Header from '../../../Layout/Header'
import { Circle } from '../../TheMoshiDifference/TheMoshiDifference'
class index extends Component {
	render() {
		return (
			<div className="page-case-study">
				<Header
					bg="#000"
					title={"Bunbury Runners Club"}
					image={require('./video.jpg')}
				/>
				<div className="entry-content">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">A new online presence for a very successful local sports club</div>
						</h2>
						<div className="row">
							<div className="col-lg-1"></div>
							<div className="col-lg-3">
								<Circle image={require('../../ContactUs/bunbury-runners-club.png')} />
							</div>
							<div className="col-lg-1"></div>
							<div className="col-lg-6">
								<div className="tagline">Moshi Moshi designed a website to both promote the Bunbury Runners Club's many popular events as well as help provide a platform to communicate with members.</div>
								<p>Assistance included:</p>
								<ul className="with-icons">
									<li>Website <a href="https://www.bunburyrunnersclub.org.au" target="_blank">www.bunburyrunnersclub.org.au</a></li>
									<li>Custom designed for visual impact</li>
									<li>Responsive design to work on all devices</li>
									<li>Animated elements for smooth flow</li>
									<li>Automated email newsletter created from website news posts</li>
								</ul>
							</div>
						</div>
					</div>

					<div className="container-fluid example-work">
						<div className="row">
						<div className="col-lg-1"></div>
						<div className="col-lg-6">
							<img src={require('./feature.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-4">
								<img src={require('./example-1.jpg')} alt="Nites Electrical Feature" width="100%" />
								<img src={require('./example-2.jpg')} alt="Nites Electrical Feature" width="100%" />
								<img src={require('./example-3.jpg')} alt="Nites Electrical Feature" width="100%" />
						</div>
							<div className="col-lg-1"></div>
						</div>
					</div>


					

				</div>


			</div>
		);
	}
}

export default index;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeveDone/BunburyRunnersClub/index.js